import React, { useEffect, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Cross, BackThick } from 'sushiweb/Icons';
import { RadioGroupV2, Textarea, SubHeading } from '../../../../UiKit';
import { Button } from '@grofers/react';
import { black } from 'sushiweb/tokens/color';
import MultiSelectViewV2 from '../../ReportIssue/Issues/common/MultiSelectView/MultiSelectV2';
import {
  IVAApprovalContinueBtnClickEvent,
  IVAReasonSelectionEvent,
} from '../../../../analytics/raise-an-issue/events';
import { MetricsForJumboEvent } from '../../../../analytics/constants';

const HandoverReasonsV2 = (props) => {
  const { handoverData } = props;
  return (
    <React.Fragment>
      {!handoverData ? (
        <Shimmer height='150px' width='100%' />
      ) : (
        <HandoverReasonsComp {...props} />
      )}
    </React.Fragment>
  );
};

export default HandoverReasonsV2;

const reasons = {
  APPROVE: '2',
  REJECT: '3',
};

const HandoverReasonsComp = (props) => {
  const { handoverData, goBack, selectedBtn, sendAction, userId, cartId } =
    props;
  const [showPopup, setShowPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [requesteditems, setRequestedItems] = useState(null);
  const [comment, setComment] = useState('');
  const [nestedCheckBox, setNestedCheckBox] = useState(null);
  const [nestedRadio, setNestedRadio] = useState(null);
  const [showError, setShowError] = useState(false);

  const { request_items, tags, request_id, ordered_items } = handoverData;
  const isGiftingPackingIssue =
    handoverData?.complaint_type === 'COMPLAINT_GIFT_PACKING_CHARGE' &&
    handoverData?.extra_charges?.length
      ? true
      : false;

  const skipItemSelectionScreen = handoverData?.skip_item_screen;

  const selectedBtnType = selectedBtn.type.toLowerCase();
  let items = tags[selectedBtnType],
    timerID1 = null;

  const handleGoBack = () => {
    selectedReason && setShowPopup(false);
  };

  const getSpoiledItemsV2 = (items) => {
    return (
      items &&
      items.map((item) => {
        if (!item) return item;
        return {
          ...item,
          quantity:
            ordered_items?.find((oi) => oi?.item_id === item.id)?.quantity ??
            item.quantity,
        };
      })
    );
  };

  const selectedSpoiledItemsV2 = (requesteditems) => {
    if (!Object.keys(requesteditems)?.length) setRequestedItems(null);
    else setRequestedItems(requesteditems);
  };

  const getReasons = (items) => {
    items.forEach((element) => {
      element['title'] = element.display_text;
      element['id'] = element.tag;
      element['value'] = element.tag;
      element['text'] = element.display_text;
    });

    return items;
  };

  const addComment = (event) => {
    setComment(event.target.value);
  };

  const selectDropdown = (selectedReason, item) => {
    // Reason selection jumbo event
    IVAReasonSelectionEvent({
      [MetricsForJumboEvent.order_id]: handoverData?.order_id,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.feature_meta]: {
        feature_name: 'Image Validator Reason Selection',
        selected_reason: selectedReason,
        request_id: handoverData?.request_id,
        complaint_type: handoverData?.complaint_type,
        action: selectedBtnType,
      },
    });

    setNestedRadio(null);
    setNestedCheckBox(null);
    timerID1 = setTimeout(() => {
      setSelectedReason(selectedReason);
      setNestedRadio(item.radio ? item.radio : null);
      setNestedCheckBox(item.check_box ? item.check_box : null);
    }, 0);
  };

  const handleClick = () => {
    // Continue button jumbo event
    IVAApprovalContinueBtnClickEvent({
      [MetricsForJumboEvent.order_id]: handoverData?.order_id,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.feature_meta]: {
        feature_name: 'Image Validator Approval Continue',
        action: selectedBtnType,
        request_id: handoverData?.request_id,
        complaint_type: handoverData?.complaint_type,
        selected_reason: selectedReason,
      },
    });

    selectedReason ? setShowPopup(true) : setShowError(true);
  };

  const getRequestedItemsDetailsToSubmit = () => {
    let requestedItems = null;
    if (skipItemSelectionScreen) {
      requestedItems = request_items.map((item) => {
        if (!item?.id) return null;
        return {
          id: Number(item.id),
          quantity: Number(item.quantity),
          is_pickup: true,
          custom_unit: item.custom_unit,
          custom_value: 0,
        };
      });

      // filtering out the items where no item id is available ex: gifting issue
      let filteredRequestedItems = [];
      for (let i = 0; i < requestedItems.length; i++) {
        if (requestedItems[i]?.id)
          filteredRequestedItems.push(requestedItems[i]);
      }
      return filteredRequestedItems?.length ? filteredRequestedItems : null;
    }

    return requesteditems && Object.keys(requesteditems)?.length
      ? Object.keys(requesteditems).map((item) => {
          return {
            id: Number(item),
            quantity: Number(requesteditems[item].quantity),
            is_pickup: requesteditems[item].pickup,
            custom_unit: requesteditems[item].custom_unit,
            custom_value: requesteditems[item].custom_value,
          };
        })
      : null;
  };

  const sendData = () => {
    if (
      (selectedBtnType === 'reject' && !selectedReason) ||
      (selectedBtnType === 'approve' && !selectedReason)
    ) {
      setShowError(true);
      return false;
    }

    let data = {};
    if (selectedBtnType === 'approve') {
      data = {
        reason_slug: selectedReason,
        items: getRequestedItemsDetailsToSubmit(),
        request_id,
        comment,
        is_rpu_applicable: true,
        status: reasons.APPROVE,
      };
      if (isGiftingPackingIssue) {
        data = { ...data, extra_charges: handoverData?.extra_charges };
      }
    } else {
      data = {
        reason_slug: selectedReason,
        status: reasons.REJECT,
        request_id,
      };
    }
    sendAction(data);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerID1);
      setShowPopup(false);
    };
  }, []);

  return (
    <React.Fragment>
      <div className='tw-py-5 tw-px-6 tw-bg-base-white'>
        <div className='tw-font-extrabold tw-text-500 tw-text-[#1C1C1C] tw-flex tw-items-center tw-flex-row tw-justify-between'>
          <div className='tw-flex tw-flex-row tw-items-center tw-gap-4 tw-flex-1 tw-flex-shrink-0'>
            {showPopup && (
              <div onClick={handleGoBack} className='tw-cursor-pointer'>
                <BackThick color={black} size={17} />
              </div>
            )}
            <span>
              {showPopup
                ? 'Confirm number of items'
                : `Select ${
                    selectedBtnType === 'approve' ? 'Approval' : 'Rejection'
                  } Reason`}
            </span>
          </div>
          <div onClick={goBack} className='tw-cursor-pointer'>
            <Cross size={24} color={black} />
          </div>
        </div>
      </div>

      {/* Reasons */}
      <div
        className={`tw-flex-1 tw-overflow-auto tw-mb-5 ${
          !showPopup
            ? 'tw-rounded-2xl tw-border-[#CFCFCF] tw-border-[0.6px] tw-border-solid tw-mx-6'
            : 'tw-px-6'
        }`}
      >
        {showPopup ? (
          <React.Fragment>
            {selectedReason && (
              <div css='margin-bottom:0 !important' className='box col '>
                <div
                  style={{
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                  }}
                >
                  <MultiSelectViewV2
                    items={getSpoiledItemsV2(request_items)}
                    selectItems={selectedSpoiledItemsV2}
                    customInputWidth='100%'
                    cartId={cartId}
                    userId={userId}
                    orderId={handoverData?.order_id}
                    complaintType={handoverData?.complaint_type}
                    capByOrderedQuantity={true}
                  />
                </div>
              </div>
            )}
            <div className='pt10'>
              <Textarea
                showBtn={false}
                placeholder='Comments (optional)'
                height='10vh'
                onChange={addComment}
              />
            </div>
          </React.Fragment>
        ) : (
          <RadioGroupV2
            items={getReasons(items)}
            selectOption={selectDropdown}
            selectedDropdownVal={selectedReason}
          />
        )}
      </div>

      {/* Approve/Reject Button */}
      <div className='tw-py-5 tw-px-6 tw-shadow-[0_0_16px_0_rgba(0,0,0,0.21)]'>
        {selectedBtnType === 'approve' ? (
          showPopup ? (
            <Button
              onClick={sendData}
              variant='fill'
              size='large'
              className={`tw-w-full ${
                (showError && !selectedReason) || !requesteditems
                  ? 'tw-bg-grey-300 hover:tw-bg-grey-300 active:tw-bg-grey-300'
                  : 'tw-bg-green-700 hover:tw-bg-green-700 active:tw-bg-green-700'
              }`}
              disabled={!requesteditems}
            >
              <p className='tw-text-white tw-text-200'>
                <span>{selectedBtn.btn_text}</span>
              </p>
            </Button>
          ) : (
            <React.Fragment>
              {showError && !selectedReason && (
                <SubHeading title='Please select any option' color='red' />
              )}
              <Button
                onClick={
                  isGiftingPackingIssue || skipItemSelectionScreen
                    ? sendData
                    : handleClick
                }
                size='large'
                variant='fill'
                className={`tw-w-full ${
                  !selectedReason
                    ? 'tw-bg-grey-300 hover:tw-bg-grey-300 active:tw-bg-grey-300'
                    : 'tw-bg-green-700 hover:tw-bg-green-700 active:tw-bg-green-700'
                }`}
                disabled={!selectedReason}
              >
                <p className='tw-text-white tw-text-200'>
                  <span>
                    {isGiftingPackingIssue || skipItemSelectionScreen
                      ? 'Submit'
                      : 'Continue'}
                  </span>
                </p>
              </Button>
            </React.Fragment>
          )
        ) : (
          <React.Fragment>
            {showError && !selectedReason && (
              <SubHeading title='Please select any option' color='red' />
            )}{' '}
            <Button
              onClick={sendData}
              size='large'
              variant='fill'
              className={`tw-w-full ${
                !selectedReason
                  ? 'tw-bg-grey-300 hover:tw-bg-grey-400 active:tw-bg-grey-400'
                  : 'tw-bg-red-600 hover:tw-bg-red-600 active:tw-bg-red-600'
              }`}
              disabled={!selectedReason}
            >
              <p className='tw-text-white tw-text-200'>
                <span>{selectedBtn.btn_text}</span>
              </p>
            </Button>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
